import { useState } from "react";

function hue(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 360;
  return h;
}

function monogram(name: string): string {
  const parts = name.trim().split(/[\s_-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.trim().slice(0, 2).toUpperCase() || "··";
}

/**
 * A venue or team mark: the image when there is one, otherwise a two-letter monogram on a hue
 * derived from the name, so a venue keeps the same colour everywhere. Falls back to the monogram
 * if the image fails to load.
 */
export function Mark({
  name,
  src,
  size = 18,
  round = false,
}: {
  name: string;
  src?: string | null;
  size?: number;
  round?: boolean;
}) {
  const [broken, setBroken] = useState(false);
  const radius = round ? "9999px" : `${Math.round(size * 0.3)}px`;

  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        title={name}
        width={size}
        height={size}
        onError={() => setBroken(true)}
        className="shrink-0 object-contain"
        style={{ width: size, height: size, borderRadius: radius }}
      />
    );
  }

  const h = hue(name);
  return (
    <span
      title={name}
      aria-hidden
      className="inline-flex shrink-0 items-center justify-center font-bold"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        fontSize: Math.max(8, Math.round(size * 0.42)),
        background: `hsl(${h} 45% 24%)`,
        color: `hsl(${h} 75% 86%)`,
      }}
    >
      {monogram(name)}
    </span>
  );
}
